import Vue from "vue";
export default Vue.extend({
  methods: {
    ssinFormated(ssin: string, indexes: number[], separator: string): string {
      const ssinSplit = ssin?.split("");
      for (let i = 1; i <= indexes.length; i++) {
        ssinSplit?.splice(indexes[i - 1], 0, separator);
      }
      return ssinSplit?.reduce((a, b) => a + b);
    },
    dateIsValid(date: any) {
      return !Number.isNaN(new Date(date).getTime());
    },
    parseDate(value: string): string {
      // const dateWihoutTime = value.split('T')
      const date = new Date(value);
      return [date.getDate().toLocaleString('fr-FR', { minimumIntegerDigits: 2 }), (date.getMonth() + 1).toLocaleString('fr-FR', { minimumIntegerDigits: 2 }), date.getFullYear()].join("/");
  },
    // divideAndDistributeRests(total: number, divider: number | number[], scale: number): number[] {
    //   const baseValues = (divider instanceof Array ? divider : Array(divider).fill(divider)).map(item =>
    //     this.roundNumber(total / item, scale, true)
    //   );
    //   const rest = baseValues.reduce((accumulator, item) => accumulator - item, total);
    //   return baseValues.map((item, index) =>
    //     this.roundNumber(item + (index < rest ? this.scaleNumber(baseValues.length - 1, -scale) : 0), scale)
    //   );
    // },
    // scaleNumber(value: number, scale: number): number {
    //   return value * Math.pow(10, scale);
    // },
    // roundNumber(value: number, scale: number, floor = false): number {
    //   const fct = (value: number) => (floor ? Math.floor(value) : Math.round(value));
    //   return this.scaleNumber(fct(this.scaleNumber(value, scale)), -scale);
    // },
  },
});
